import Layout from "../../components/Layout";
import AdminLessonNote from "./admin/AdminLessonNote";
import { useUserState } from "../../context/UserContext";

const index = () => {
  const { userRole } = useUserState();

  return (
    <Layout children={
      <>
        {userRole?.role_type === "school_admin" || userRole?.role_type === "employee" ? (
          <AdminLessonNote />
        ) : null}
      </>
    }
    />
  );
};

export default index;
